export default "/images/nomination1.jpg?b8e27cbc703f284d54cb5092777dd271";